module.exports = __webpack_public_path__ + "static/jade6-e0b70b29c546ac775d955810e698637a.png";